export const waitForElement = (selector: string): Promise<Element | null> => {
  return new Promise(resolve => {
    if (!selector) {
      return resolve(null);
    }
    if (document.querySelector(selector)) {
      return resolve(document.querySelector(selector));
    }

    const observer = new MutationObserver(() => {
      if (document.querySelector(selector)) {
        resolve(document.querySelector(selector));
        observer.disconnect();
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
    });
  });
};
